<template>
  <div class="footer-box">
    <div class="footer">
      <div class="footer__body clearfix">
        <div class="footer__list">
          <div class="list__title"><span>关于我们</span></div>
          <div class="Dis--flex">
            <ul class="list__item">
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutUs">关于我们</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=copyright">版权声明</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutAccount">关于账号</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aboutCard">关于会员卡</a>
              </li> -->
            </ul>
            <ul class="list__item">
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=list">帮助中心</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aqservice">广告服务</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=aqnew">新媒体广告服务</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=consume">充值/消费</a>
              </li> -->
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=custom">客服/售后</a>
              </li>
            </ul>
            <ul class="list__item">
              <!-- <li><a href="javascript:void(0);" onclick="suggestWindow();">申述/建议</a></li> -->
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=webagreement">用户协议</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=agreement">会员协议</a>
              </li>
              <li>
                <a href="https://medjournals.cn/help/helpcenter.do?to=privacyclause">隐私条款</a>
              </li>
              <li>
                <a href="https://medjournals.cn/help/helpcenter.do?to=cookiepolicy">Cookie政策</a>
              </li>
              <!-- <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=suggest">申述/建议</a>
              </li>
              <li>
                <a href="http://medjournals.cn/help/helpcenter.do?to=custom">客服/售后</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer__list">
          <div class="list__title"><span>联系我们</span></div>
          <div class="Dis--flex">
            <ul class="list__item">
              <li class="contact">
                联系电话：纸质期刊相关问题：010-51322386/2388
              </li>
              <li class="pddLeft"
                  style="padding-left: 110px">
                电子期刊/APP相关问题：010-51322487
              </li>
              <li class="email">客服邮箱：info@cmaph.org</li>
              <li class="weixin">在线客服：扫描关注二维码 或 <a href="https://cmaph.soboten.com/chat/pc/v2/index.html?sysnum=b3bcde969fc34532baa0bdb60d88f276&channelid=2" target="_blank">在线咨询</a></li>
              <!-- <li class="pddLeft"
                  style="padding-left: 40px">
                （微信号：cmaclub）或扫描右侧二维码
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer__list last">
          <div class="list__title"><span>关注菁医汇微信公众号微信号</span></div>
          <dl class="weixinBox">
            <dt>
              <img src="../../assets/img/qingyiweixin.jpg"
                   style="max-width: 120px" />
            </dt>
            <dd style="width: 120px">扫描关注公众号</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="footer__publishMsg">
      <div class="footer__publishMsg--inside">
        <p>
          <a href="https://beian.miit.gov.cn/"
             target="_blank"><span style="color: #fff">京ICP备</span><span style="color: #ff9900">07035254号-1</span></a>京公网安备<span>11010102000192号</span>出版物经营许可证<span>新出发京零字第东130025号</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Get, Post } from '@/api/axios'
export default {
  data() {
    return {}
  },
  created() {
    // 这个是为了解决退出登录后 报错使用，用于获取最新的UUID
    setInterval(() => {
      if (
        localStorage.getItem('memberId') &&
        window.location.href.indexOf('/personal') != -1
      ) {
        // this.goSm();
      }
    }, 18000)
  },
  methods: {
    goSm() {
      Get(
        '/member/spc/' +
          window.version +
          '/authentication/find?type=2&orgCode=REAL_NAME' +
          '&userId=' +
          localStorage.getItem('memberId')
      ).then((res) => {

      })

    },
  },
}
</script>
<style lang="scss" scoped>
.footer-box {
  position: absolute;
  // bottom: 0px;
  left: 0;
  width: 100%;
  z-index: 1;
  // margin-top: 20px;
}
/* footer */
.footer {
  background: #016072;
  height: 310px;
}

.footer__body {
  width: 1200px;
  margin: 0 auto;
  padding-top: 35px;
}

.footer__list {
  float: left;
  width: 375px;
  margin-right: 110px;
}

.footer__list.last {
  width: 230px;
  margin-right: 0;
}

.footer__list .list__title {
  color: rgba(255, 255, 255, 0.7);
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 15px;
  margin-bottom: 20px;
}

.footer__list .Dis--flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}

.footer__list .list__item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.footer__list .list__item li {
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  color: rgba(255, 255, 255, 0.5);
}

.footer__list .list__item li a {
  display: inline-block;
  background: url('../../../static/img/point.png') no-repeat left 6px center;
  padding-left: 15px;
  color: rgba(255, 255, 255, 0.5);
}
.footer__list .list__item li :hover {
  opacity: 0.8;
}
.footer__list .list__item li a:hover {
  color: #fff;
  opacity: 0.8;
  background: url('../../../static/img/point1.png') no-repeat left 6px center;
}

.footer__list .weixinBox dd {
  line-height: 30px;
  height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

.footer__list .weixinBox {
  padding: 0 20px 20px;
  width: 120px;
}

.footer__list .list__item li.contact {
  background: url('../../../static/img/publish_icon1.png') no-repeat left 10px
    center;
  padding-left: 45px;
}

.footer__list .list__item li.email {
  background: url('../../../static/img/publish_icon2.png') no-repeat left 10px
    center;
  padding-left: 45px;
}

.footer__list .list__item li.weixin {
  background: url('../../../static/img/publish_icon3.png') no-repeat left 10px
    center;
  padding-left: 45px;
  a{
	  background: none;
	  padding: 0;
	  text-decoration: underline;
  }
}

.footer__publishMsg {
  background-color: #015263;
  height: 45px;
  text-align: center;
  font-size: 12px;
  color: #fefefe;
  line-height: 45px;
}

.footer__publishMsg p {
  background: url('../../../static/img/footer_b.png') no-repeat left center;
  padding-left: 32px;
  display: inline-block;
  *display: inline;
  zoom: 1;
}

.footer__publishMsg span {
  color: #ff9900;
  margin-left: 9px;
  margin-right: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue